import { apiEndPoints } from "../../ApiServices/config";
import { getApi, postApi } from "../../ApiServices/api";
import { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCart } from "../../actions/index";
import toast from "react-hot-toast";

function useExpressBooking(watch,navigate,remove,append,defaultValues) {
    const [monthlyServiceData, setMonthlyServiceData] = useState();
    const [weeklyServiceData, setWeeklyServiceData] = useState();
    const [dailyServiceData, setDailyServiceData] = useState();
    const [visibleRows, setVisibleRows] = useState(3);
    const [serviceData, setServiceData] = useState();
    const dispatch = useDispatch();
    const cartArr = useSelector((state) => state.cartArr);
    const devoteeData = JSON.parse(localStorage.getItem("devoteeData"));
    const isDevoteeLoggedIn = localStorage.getItem("token");
    const [quantity, setQuantity] = useState(1);    
    const [nakshatra, setNakshatra] = useState();

    const dailyServicePayload = {
        slug: "daily",
      };
    const weeklyServicePayload = {
        slug: "weekly",
    };
    const monthlyServicePayload = {
        slug: "monthly",
    };

    const incrementQuantity = () => {
        setQuantity((prevQuantity) => prevQuantity + 1);
    };

    const decrementQuantity = () => {
        setQuantity((prevQuantity) => (prevQuantity > 1 ? prevQuantity - 1 : 1));
    };

    const handleChildrenRemove = (index) => {
        remove(index);
    };
    
    const handleClickAddRow = () => {
        append(defaultValues);
        setVisibleRows(visibleRows + 1);
    };

    const getNakshatra = async () => {
        const response = await getApi(apiEndPoints.nakshatram);
        if (response && response.status === 200) {
          setNakshatra(response?.data?.data);
        }
    };
    
    const getServiceData = async () => {
        try {
          const response = await getApi(
            `${apiEndPoints.getSpecificService}/${watch("pooja_id")}`
          );
          setServiceData(response?.data?.data[0]);
        } catch (error) {
          console.log(error);
        }
    };

    const getMonthlyServicesData = async () => {
        try {
            const response = await postApi(
                apiEndPoints.getAllServicesAtTempleByServicesSlug,
                monthlyServicePayload
            );
            setMonthlyServiceData(response.data.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getWeeklyServicesData = async () => {
        try {
            const response = await postApi(
                apiEndPoints.getAllServicesAtTempleByServicesSlug,
                weeklyServicePayload
            );
            setWeeklyServiceData(response.data.data);
        } catch (error) {
            console.log(error);
        }
    };
    
    const getReligiousServices = async () => {
        const response = await postApi(
            apiEndPoints.getAllServicesAtTempleByServicesSlug,
            dailyServicePayload
        );
        if (response && response.status === 200) {
            setDailyServiceData(response?.data?.data);
        }
    };

    const onSubmit = async (data) => {
        const result = filterById(data.pooja_id);
        const booking_config = result[0].booking_config;
        if (booking_config === "Online booking not available call temple to book") {
          const response = await postApi(apiEndPoints.getBookingConfigByTitle, {
            title: booking_config,
          });
          toast.error(response.data.data.data.message);
          return;
        }
        data.title = `${serviceData?.title} (Express Booking) `;
        data.type = 4;
        data.quantity = quantity;
        data.selectedDate = new Date(watch("starting_date"));
        data.amount = serviceData?.amount;
        const devoteeDetails = {
          first_name: data?.first_name,
          last_name: data?.last_name,
          email: devoteeData?.email || "",
          country: devoteeData?.country || "",
          state: devoteeData?.state || "",
          conatct_number: devoteeData?.conatct_number || "",
          zipCode: devoteeData?.zipcode || "",
          city: devoteeData?.city,
          address: devoteeData?.address,
          persons: data?.persons?.map((item) => item),
        };
        if (!isDevoteeLoggedIn) {
          localStorage.setItem("devoteeData", JSON.stringify(devoteeDetails));
        } else {
          localStorage.setItem("devoteeData", JSON.stringify(devoteeData));
        }
    
        const modifiedData = { ...data };
        delete modifiedData.first_name;
        delete modifiedData.last_name;
        delete modifiedData.persons;
    
        const existingCartItem = cartArr.find(
          (cartItem) => cartItem._id === data.pooja_id
        );
    
        if (existingCartItem) {
          const updatedItem = {
            ...existingCartItem,
            quantity: quantity || 1,
            selectedDate: data.starting_date,
          };
          dispatch(updateCart(updatedItem));
          navigate("/checkout");
        } else {
          const newItem = {
            ...modifiedData,
            quantity: quantity || 1,
            selectedDate: data.starting_date,
          };
          dispatch(updateCart(newItem));
          navigate("/checkout");
        }
    };
    

    const filterById = (id) => {
        const monthlyMatch = monthlyServiceData.filter((item) => item._id === id);
        const weeklyMatch = weeklyServiceData.filter((item) => item._id === id);
        const dailyMatch = dailyServiceData.filter((item) => item._id === id);
    
        const filteredData = [...monthlyMatch, ...weeklyMatch, ...dailyMatch];
        return filteredData;
    };

    useEffect(() => {
        getMonthlyServicesData();
        getWeeklyServicesData();
        getReligiousServices();
        getNakshatra();
    },[])
    
    return {
        monthlyServiceData,
        weeklyServiceData,
        dailyServiceData,
        quantity,
        setQuantity,
        incrementQuantity,
        decrementQuantity,
        devoteeData,
        isDevoteeLoggedIn,
        serviceData,
        setServiceData,
        getServiceData,
        nakshatra,
        setNakshatra,
        onSubmit,
        handleClickAddRow,
        handleChildrenRemove
      }

}

export default useExpressBooking;